import {
  displayFormattedDate,
  removeWebpackErrorOverlay,
} from "./commonService";
import iq_api from "./iqApi";
import api from "./api";
import iq_api_v2 from "../services/iqApiV2";
import iq_download from "./iqDownload";
import qs from "qs";
import { iqChat } from "./iqChat";
import sales_iq_v2_api from "../services/salesIqV2Api";
import revenue_teardown_api from "./revenueTeardownApi";

// Function to fetch account info
export const fetchAccountInfo = async (accountName) => {
  try {
    const response = await iq_api.post("/chatgpt/account_details", {
      account_name: accountName,
    });

    let result = response?.data?.records?.[0] ?? [];
    // console.log(result);
    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account details error:", error);
    throw error;
  }
};

export const fetchAccountDetails = async (
  accountId,
  accountName,
  clientName
) => {
  try {
    const response = await iq_api.post("/chatgpt/account_all_details", {
      account_name: accountName,
      client_name: clientName,
    });

    let result = response?.data?.records ?? [];

    delete result.business_unit_overview_extra;

    // Reform overview text data
    let overview = result.overview;
    let transformed_overview = overview?.[0]?.data?.[0]?.text || "";
    result.overview = transformed_overview;
    // End: Reform overview text data

    // Reform key products and services data
    let key_products_services = result?.key_products_services || [];
    /*
    let transformed_key_products_services = key_products_services?.map(bu => ({
        "bu_name": bu._id.business_unit,
        "products_and_services": bu.data[0].data.map(product => ({
            "name": product.name,
            "description": product.description || ""
        })
        )
    }));
    */

    // console.log(key_products_services)

    let transformed_key_products_services =
      key_products_services?.map((bu) => {
        try {
          return {
            bu_name: bu?._id?.business_unit || "", // Safely access business_unit or fallback to 'N/A'
            products_and_services:
              bu?.data?.[0]?.data?.map((product) => {
                try {
                  return {
                    name: product?.name || "", // Fallback to a default if name is missing
                    description: product?.description || "", // Safely handle description or provide an empty string
                  };
                } catch (error) {
                  console.log("err", error);
                }
              }) || [], // Ensure an empty array if bu.data[0].data is invalid or missing
          };
        } catch (error) {
          console.log("error ", error);
        }
      }) || []; // Return an empty array if key_products_services is undefined or null

    // Filter product name if blank
    transformed_key_products_services = transformed_key_products_services.map(
      (bu) =>
        bu?.products_and_services && {
          ...bu,
          products_and_services: bu?.products_and_services.filter(
            (ps) => ps.name.trim() !== ""
          ),
        }
    );
    /* .filter(bu => bu.products_and_services.length > 0) */
    // End: Filter product name if blank
    // console.log('transformed_key_products_services', transformed_key_products_services);

    result.key_products_services = transformed_key_products_services || [];
    // End: Reform key products and services data

    // Reform strategic priorities data
    let strategic_priorities = result.strategic_priorities;
    let transformed_strategic_priorities =
      strategic_priorities?.[0]?.data?.[0]?.data || [];
    result.strategic_priorities = transformed_strategic_priorities;
    // End: Reform strategic priorities data

    // console.log(result);
    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account details error:", error);
    throw error;
  }
};
export const fetchAccountCompetitors = async (
  accountId,
  accountName,
  clientName
) => {
  try {
    const response = await iq_api.post("/competitors/global-competitors", {
      account_name: accountName,
      client_name: clientName,
    });

    let result = response?.data?.records ?? [];

    let finalResult = {};
    finalResult.competitors = result?.competitors || [];

    return finalResult;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account details error:", error);
    throw error;
  }
};

export const fetchBusinessUnitAccountDetails = async (
  accountName,
  clientName,
  business_unit
) => {
  try {
    const response = await iq_api.post(
      "/chatgpt/account_details_by_business_unit",
      {
        account_name: accountName,
        client_name: clientName,
        business_unit: business_unit,
      }
    );

    let result = response?.data?.records ?? [];

    let finalResult = {};

    finalResult.account_bu_futuristic_trends =
      result?.account_bu_futuristic_trends || [];

    finalResult.account_bu_key_competitors =
      result?.account_bu_key_competitors?.[0]?.data || [];

    finalResult.business_unit_overview =
      result?.business_unit_overview?.[0]?.text || "";

    finalResult.customer_segment_and_key_customers =
      result?.customer_segment_and_key_customers?.[0]?.data || [];

    finalResult.growth_opportunities_shortlisted_markets =
      result?.growth_opportunities_shortlisted_markets?.[0]?.data || [];

    finalResult.key_products_services =
      result?.key_products_services?.[0]?.data || [];

    finalResult.mcp_pain_point = result?.mcp_pain_point?.[0]?.data || [];

    finalResult.business_units = result?.business_units?.[0] || [];

    result = {};

    // console.log(result);
    return finalResult;
  } catch (error) {
    console.log(error);
    console.error("Fetch BU Account details error:", error);
    throw error;
  }
};

/*
const getSortedNudges = (nudges) => {
  const sortedNudges = nudges.map(category => {
    return {
        ...category,
        data: category.data.sort((a, b) => {
            const dateA = new Date(displayFormattedDate(a.published_date, 'YYYY-MM-DD'));
            const dateB = new Date(displayFormattedDate(b.published_date, 'YYYY-MM-DD'));

            // Compare by published_date (latest first)
            if (dateA > dateB) return -1;
            if (dateA < dateB) return 1;

            // If dates are the same, compare by relevance_score (largest first)
            return b.relevance_score - a.relevance_score;
        })
    };
  });

  return sortedNudges;
}
*/

/*
const getSortedNudges = (nudges) => {
  // Sort nudges based on event_date and impact_score
  return nudges.sort((a, b) => {
    const dateA = new Date(displayFormattedDate(a.event_date, "YYYY-MM-DD"));
    const dateB = new Date(displayFormattedDate(b.event_date, "YYYY-MM-DD"));

    // Compare by event_date (latest first)
    if (dateA > dateB) return -1;
    if (dateA < dateB) return 1;

    // If event_date is the same, compare by impact_score (largest first)
    return b.impact_score - a.impact_score;
  });
};
*/

const getSortedNudges = (nudges) => {
  return nudges.sort((a, b) => {
    // Ensure event_date is in a valid format for Safari
    const dateA = new Date(
      displayFormattedDate(a.event_date, "YYYY-MM-DD").replace(/-/g, "/")
    );
    const dateB = new Date(
      displayFormattedDate(b.event_date, "YYYY-MM-DD").replace(/-/g, "/")
    );

    if (isNaN(dateA) || isNaN(dateB)) return 0; // Handle invalid dates

    // Compare by event_date (latest first)
    if (dateA > dateB) return -1;
    if (dateA < dateB) return 1;

    // If event_date is the same, compare by impact_score (largest first)
    return (b.impact_score || 0) - (a.impact_score || 0);
  });
};

export const fetchAccountBUNudges = async (
  accountName,
  clientName,
  business_unit
) => {
  try {
    let API_URL = "/chatgpt/v2/get_nudges";
    const response = await iq_api.post(API_URL, {
      account: accountName,
      client: clientName,
      business_unit: business_unit,
    });

    let result = response?.data?.records ?? [];
    const version = response?.data?.version;

    // Process and normalize the data
    result?.forEach((category, index) => {
      category.id = index; // Assign Id to each category

      // Iterate over the data array in each category
      category.data?.forEach((nudgeData) => {
        // Iterate over the nudges array inside each nudgeData
        nudgeData.nudges?.nudges?.forEach((nudge, index_2) => {
          nudge.id = index + "_" + index_2;
          // Normalize relevant_solutions to an array if it's not already an array
          if (typeof nudge?.relevant_solutions === "string") {
            nudge.relevant_solutions = [];
          } else if (
            nudge?.relevant_solutions &&
            typeof nudge?.relevant_solutions === "object" &&
            !Array.isArray(nudge?.relevant_solutions)
          ) {
            // Convert object to an array of keys
            nudge.relevant_solutions = Object.keys(nudge.relevant_solutions);
          }

          // Normalize value_selling_prompters to an array if it's not already an array
          if (typeof nudge?.value_selling_prompters === "string") {
            nudge.value_selling_prompters = [];
          } else if (
            nudge?.value_selling_prompters &&
            typeof nudge?.value_selling_prompters === "object" &&
            !Array.isArray(nudge?.value_selling_prompters)
          ) {
            // Convert object to an array of keys
            nudge.value_selling_prompters = Object.keys(
              nudge.value_selling_prompters
            );
          }
        });
      });
    });

    /*
    // Assign Id
    result?.forEach((nudge_data, index) => {
      nudge_data.id = index;

      // Normalize relevant_solutions to an array if it is an object
      if (typeof nudge_data?.relevant_solutions === 'string'){
        nudge_data.relevant_solutions = []
      }
      else if (nudge_data?.relevant_solutions && typeof nudge_data?.relevant_solutions === "object" && !Array.isArray(nudge_data?.relevant_solutions)) {
          // Convert object to an array of keys
          nudge_data.relevant_solutions = Object.keys(nudge_data.relevant_solutions);
      }

      // Normalize relevant_solutions to an array if it is an object
      if (typeof nudge_data?.value_selling_prompters === 'string'){
        nudge_data.value_selling_prompters = []
      }
      else if (nudge_data?.value_selling_prompters && typeof nudge_data?.value_selling_prompters === "object" && !Array.isArray(nudge_data?.value_selling_prompters)) {
          // Convert object to an array of keys
          nudge_data.value_selling_prompters = Object.keys(nudge_data.value_selling_prompters);
      }

    });
    */

    // result = getSortedNudges(result)

    return { result, version };
  } catch (error) {
    console.log(error);
    console.error("Fetch Account BU Nudges error:", error);
    throw error;
  }
};

export const fetchOpportunityContacts = async (opportunityId) => {
  try {
    const response = await iq_api.post(
      "/chatgpt/v2/get_nudge_contacts",
      { id: opportunityId } // Request body
    );

    let result = response?.data?.records ?? [];
    return result;
  } catch (error) {
    console.error("Fetch Opportunity Contacts error:", error);
    throw error;
  }
};

export const fetchClientNudges = async (clientName) => {
  if (!clientName) {
    return [];
  }
  try {
    const response = await iq_api.post("/client/nudges", {
      client: clientName,
    });

    let result = response?.data?.records ?? [];

    result = getSortedNudges(result);

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Client Nudges error:", error);
    throw error;
  }
};

export const fetchAccountBUUseCaseQuestions = async (
  accountName,
  clientName,
  business_unit,
  use_case
) => {
  let params = {
    account: accountName,
    client: clientName,
    business_unit: business_unit,
    use_case: use_case,
  };

  try {
    const response = await iq_api.post(
      "/chatgpt/get_key_questions_and_email",
      params
    );

    let result = response?.data?.records ?? [];

    /*** Transform Data */

    if (use_case === "for_tab") {
      let transformed_prompter_questions_tab = {};

      if (
        result?.prompter_questions_tab?.data &&
        typeof result?.prompter_questions_tab?.data === "object" &&
        Object.entries(result?.prompter_questions_tab?.data).length
      ) {
        // console.log("AAA result.prompter_questions_tab.data: ", result.prompter_questions_tab.data)

        transformed_prompter_questions_tab = {
          data: Object.entries(result?.prompter_questions_tab?.data).map(
            ([name, { use_cases }]) => ({
              name,
              use_cases,
            })
          ),
        };
      }

      // Set the transformed data or default to an empty array
      result.prompter_questions_tab = Object.keys(
        transformed_prompter_questions_tab
      ).length
        ? transformed_prompter_questions_tab
        : {};

      result?.prompter_questions_tab?.data?.map((data, index) => {
        data.number_of_use_cases = data?.use_cases?.length || 0;
        data?.use_cases?.map((use_case, index_2) => {
          use_case.id = index + "_" + index_2;
        });
      });

      // Sort by number_of_use_cases (descending) and then by name (alphabetical ascending)
      result?.prompter_questions_tab?.data?.sort((a, b) => {
        if (b.number_of_use_cases !== a.number_of_use_cases) {
          return b.number_of_use_cases - a.number_of_use_cases; // Primary sort (descending)
        }
        return (a.name || "").localeCompare(b.name || ""); // Secondary sort (alphabetical ascending)
      });
    }

    // console.log("result.prompter_questions_tab : ", result.prompter_questions_tab)

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account BU Market questions error:", error);
    throw error;
  }
};

export const fetchAccountBUUseCaseDescription = async (
  accountName,
  clientName,
  business_unit,
  use_case
) => {
  try {
    const response = await iq_api.post("/opportunities/usecase_narrative", {
      account: accountName,
      client: clientName,
      business_unit: business_unit,
      use_case: use_case,
    });

    let result = response?.data?.records?.description?.[0] ?? "";

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account BU Market use case description error:", error);
    throw error;
  }
};

export const fetchGrowthOpportunitiesByAccountAndClient = async (
  accountId,
  accountName,
  clientName
) => {
  try {
    const response = await iq_api.post("/opportunities/use-cases", {
      account_name: accountName,
      client_name: clientName,
    });

    let result = response?.data?.records ?? [];

    return {
      opportunities: result?.opportunities || [],
    };
  } catch (error) {
    setTimeout(function () {
      removeWebpackErrorOverlay();
    }, 1000);

    // Log more specific error details if available
    if (error.response) {
      console.error(`Error ${error.response.status}:`, error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error in setting up request:", error.message);
    }

    // Re-throw error to propagate it up the call stack
    throw error;
  }
};

export const fetchClientsAccountsList = async (accountId, clientName) => {
  try {
    const response = await iq_api.post("/client/accounts", {
      client_name: clientName,
    });

    let result = response?.data?.records ?? [];

    let finalResult = {};
    finalResult.accounts = result?.accounts || [];

    return finalResult;
  } catch (error) {
    console.log(error);
    console.error("Fetch Clients Accounts List error:", error);
    throw error;
  }
};

export const fetchCompanyFinancials = async (
  competitorName,
  identifier,
  vendor_company_id
) => {
  try {
    // const response = await iq_api.post("/account/financials", {
    //   account: accountName,
    // });

    // const response = await iq_api.post("/wrappers/key_financials", {
    //   account: competitorName,
    //   ticker: identifier,
    // });

    const update_data = {
      // account: competitorName,
      // ticker: identifier,
      ciq_id: vendor_company_id,
    };

    const queryString = qs.stringify(update_data, { skipNulls: false });
    // const response = await iq_api.post(
    //   "/wrappers/key_financials?" + queryString
    // );

    const response = await iq_api.post(
      "/wrappers/key_financials_v2?" + queryString
    );

    let result = response?.data?.body ?? [];

    return result || [];
  } catch (error) {
    console.error("Fetch Accounts Financials error:", error);
    throw error;
  }
};

export const fetchCompanyBuFinancials = async (
  accountId,
  accountName,
  business_unit
) => {
  try {
    const response = await iq_api.post("/account/business_unit_financials", {
      account: accountName,
      business_unit: business_unit,
    });

    let result = response?.data?.records?.[0] ?? [];
    let finalResult = {};
    finalResult.data = result || [];

    return finalResult || [];
  } catch (error) {
    console.error("Fetch Accounts Financials error:", error);
    throw error;
  }
};

export const fetchClientProductOpportunities = async (
  accountId,
  accountName,
  clientName
) => {
  try {
    const response = await iq_api.post(
      "/chatgpt/client_product_opportunities",
      {
        account: accountName,
        client: clientName,
      }
    );

    let result = response?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account details error:", error);
    throw error;
  }
};

function getDistinctContactsCounts(data, field) {
  const counts = {};

  data.forEach((item) => {
    let value = item[field] || "Other"; // Default to 'Other' if field is null, undefined, or empty
    if (value.toLowerCase() === "others") {
      value = "Other"; // Normalize 'Others' to 'Other'
    }
    counts[value] = (counts[value] || 0) + 1;
  });

  const entries = Object.entries(counts).map(([name, count]) => ({
    name,
    count,
  }));
  entries.sort((a, b) =>
    a.name === "Other" ? 1 : b.name === "Other" ? -1 : 0
  ); // Ensure 'Other' is last
  return entries;
}

export const fetchAccountContacts = async (accountName) => {
  try {
    const response = await iq_api.post("/account/contacts", {
      company: accountName,
    });

    let result = response?.data?.records ?? [];

    // result = result.splice(0, 4);

    result = result.map((item) => {
      return {
        ...item,
        function:
          typeof item?.function === undefined ||
          item?.function === "" ||
          item?.function?.toLowerCase() == "other" ||
          item?.function?.toLowerCase() == "others"
            ? "Other"
            : item?.function,
        management_level:
          typeof item?.management_level === undefined ||
          item?.management_level === "" ||
          item?.management_level?.toLowerCase() == "other" ||
          item?.management_level?.toLowerCase() == "others"
            ? "Other"
            : item?.management_level,
      };
    });

    const finalResult = {
      records: result,
      filters: {
        function: getDistinctContactsCounts(result, "function"),
        management_level: getDistinctContactsCounts(result, "management_level"),
      },
    };

    return finalResult;
  } catch (error) {
    console.log(error);
    console.error("Fetch Account details error:", error);
    throw error;
  }
};

export const fetchCompanyKeyCompetitorsTable = async (ticker) => {
  try {
    const response = await iq_api.post("/account/competitor_analysis", {
      ticker: ticker,
    });

    let result = response?.data?.records ?? [];

    return result || [];
  } catch (error) {
    console.error("Fetch Company Key Competitors Table error:", error);
    throw error;
  }
};

export const fetchTechnologyLandscape = async (company) => {
  try {
    const response = await iq_api.post("/account/vendors", {
      company: company,
    });

    let result = response?.data?.records ?? [];
    //console.log(result);
    return result || [];
  } catch (error) {
    console.error("Fetch Technology Landscape error:", error);
    throw error;
  }
};
export const fetchKeyTechnologies = async (company) => {
  try {
    const response = await iq_api.post("/account/key_technologies", {
      account: company,
      //account: 'THE BOEING COMPANY'
    });

    let result = response?.data?.records ?? [];
    //console.log(result);
    return result || [];
  } catch (error) {
    console.error("Fetch Key Technology error:", error);
    throw error;
  }
};
export const fetchNewProjects = async (ticker) => {
  try {
    const response = await iq_api.post("account/projects", {
      ticker: ticker,
      //ticker: 'BA:NYSE'
    });

    let result = response?.data?.records ?? [];
    //console.log(result);
    return result || [];
  } catch (error) {
    console.error("Fetch New Projects error:", error);
    throw error;
  }
};

export const fetchFinancials = async (ticker) => {
  try {
    const response = await iq_api.post("/account/self_financials", {
      ticker: ticker,
      //  ticker: 'BA:NYSE'
    });

    let result = response?.data?.records ?? [];
    return result || [];
  } catch (error) {
    console.error("Fetch Financials error:", error);
    throw error;
  }
};

export const fetchDocuments = async (ticker) => {
  try {
    const response = await iq_api.post("/account/documents", {
      ticker: ticker,
      //  ticker: 'BA:NYSE'
    });

    let result = response?.data?.records ?? [];
    return result || [];
  } catch (error) {
    console.error("Fetch Documents error:", error);
    throw error;
  }
};

// export const fetchBusinessRevenueAnalysis = async (ticker) => {
//   try {
//     var response = [];
//     // if (ticker) {
//     //   response = await iq_api.post(
//     //     "/wrappers/revenue_analysis",
//     //     { company: ticker },
//     //     {}
//     //   );
//     // }

//     const update_data = {
//       company: ticker,
//     };
//     const queryString = qs.stringify(update_data, { skipNulls: false });
//     response = await iq_api.post("/wrappers/revenue_analysis?" + queryString);

//     let revenueAnalysisData = response?.data?.business_units || [];

//     return revenueAnalysisData;
//   } catch (error) {
//     console.error("Fetch fetchBusinessRevenueAnalysis error:", error);
//     throw error;
//   }
// };

export const fetchBusinessRevenueAnalysis = async (ticker) => {
  try {
    let response = [];
    if (ticker) {
      const queryString = qs.stringify(
        { identifier: ticker },
        { skipNulls: false }
      );

      response = await sales_iq_v2_api.get(
        `/company/get_company_business_geo_segments?${queryString}`
      );
    }

    const revenueAnalysisData = response?.data || {};

    return revenueAnalysisData;
  } catch (error) {
    console.error("Fetch fetchBusinessRevenueAnalysis error:", error);
    throw error;
  }
};

export const fetchGeoWiseRevenueAnalysis = async (ticker) => {
  try {
    var response = [];
    // if (ticker) {
    //   response = await iq_api.post("/chatgpt/geo-segments", { ticker: ticker });
    // }
    // if (ticker) {
    //   response = await iq_api.post("/wrappers/geo-segments", {
    //     ticker: ticker,
    //   });
    // }

    const update_data = {
      ticker: ticker,
    };
    const queryString = qs.stringify(update_data, { skipNulls: false });
    response = await iq_api.post("/wrappers/geo-segments?" + queryString);

    let revenueAnalysisData = response?.data || [];

    return revenueAnalysisData;
  } catch (error) {
    console.error("Fetch fetchGeoWiseRevenueAnalysis error:", error);
    throw error;
  }
};

export const fetchChatRequestResponse = async (
  question_string,
  client_company_name
) => {
  let requestObjParam = {};
  //requestObjParam.username = "mnm-internal";
  // requestObjParam.Password = "Ks$a_(*Bhjsa@bv%$6^l";
  requestObjParam.input = question_string;
  requestObjParam.client_name = client_company_name;

  try {
    var response = [];
    if (question_string) {
      response = await iq_api.post("/chatgpt/aiq-copilot", requestObjParam);
    }

    return response.data || {};
  } catch (error) {
    console.error("Fetch chatgpt/aiq-copilot error:", error);
    throw error;
  }
};

export const fetchChatRequestFollowUp = async (
  question_string,
  client_name
) => {
  let requestObjParam = {};
  //requestObjParam.username = "mnm-internal";
  // requestObjParam.Password = "Ks$a_(*Bhjsa@bv%$6^l";
  requestObjParam.input = question_string;
  requestObjParam.client_name = client_name;

  try {
    var response = [];
    if (question_string) {
      response = await iq_api.post("/chatgpt/aiq-followup", requestObjParam);
    }

    return response.data || {};
  } catch (error) {
    console.error("Fetch chatgpt/follow-up error:", error);
    throw error;
  }
};

export const fetchDefaultAccountsQuestions = async (
  accountId,
  accountName,
  clientName
) => {
  try {
    const response = await iq_api.post("/account/chat-question_templates", {
      account: accountName,
      client: clientName,
    });

    let result = response?.data?.records ?? [];
    return result;
  } catch (error) {
    setTimeout(function () {
      removeWebpackErrorOverlay();
    }, 1000);

    // Log more specific error details if available
    if (error.response) {
      console.error(`Error ${error.response.status}:`, error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error in setting up request:", error.message);
    }

    // Re-throw error to propagate it up the call stack
    throw error;
  }
};

export const updateData = async (apiType, data) => {
  try {
    var response = [];
    response = await api.post("/" + apiType + "/update_status_field", data);
    let updateDataStatus = response || [];
    return updateDataStatus;
  } catch (error) {
    console.error("Update Data error:", error);
    throw error;
  }
};

export const fetchSegments = async (accountName) => {
  try {
    const response = await iq_api.post("/chatgpt/segments", {
      company: accountName,
    });
    return response;
  } catch (error) {
    console.error("fetchSegments Data error:", error);
    throw error;
  }
};

export const fetchKeyConversations = async (accountName) => {
  try {
    const response = await iq_api.post("/chatgpt/key_conversations", {
      company: accountName,
    });
    return response;
  } catch (error) {
    console.error("fetchKeyConversations Data error:", error);
    throw error;
  }
};

export const fetchClosureAgent = async (
  clientName = "",
  accountName = "",
  contact = "",
  context = "",
  contextFile = null,
  outputFile = null,
  responseType = ""
) => {
  try {
    const formData = new FormData();
    formData.append("client_name", clientName);
    formData.append("account_name", accountName);
    formData.append("context", context);
    formData.append("persona_name", contact);
    formData.append("response_type", responseType);

    if (contextFile) {
      formData.append("contextFile", contextFile); // Append the PDF/DOCX file
    }

    if (outputFile) {
      formData.append("outputFile", outputFile); // Append the PDF/DOCX file
    }

    const response = await api.post("/notes/get_closure_note", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: responseType === "pdf" ? "blob" : "json",
    });

    if (responseType === "pdf") {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "closure_note.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      let result = response?.data?.result ?? [];
      return result;
    }
  } catch (error) {
    console.log(error);
    console.error("Fetch Closure Agent Error:", error);
    throw error;
  }
};

export const fetchChampionAgent = async (
  contact = "",
  context = "",
  responseType = "pdf"
) => {
  try {
    let contact_updated = contact.replace(/ /g, "_");
    const formData = new FormData();
    formData.append("contact_name", contact_updated);
    formData.append("context", context);
    formData.append("response_type", responseType);

    // const response = await api.post("/notes/get_champion_note", {
    //   params: {
    //     contact_name: contact_updated,
    //     context: context,
    //   },
    // });

    const response = await api.post("/notes/get_champion_note", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: responseType === "pdf" ? "blob" : "json",
    });

    if (responseType === "pdf") {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "champion_note.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      let result = response?.data?.result ?? [];
      return result;
    }
  } catch (error) {
    console.log(error);
    console.error("Fetch Champion Agent Error:", error);
    throw error;
  }
};

export const fetchDeliveryExcellenceAgent = async (
  clientName = "",
  accountName = "",
  context = "",
  contextFile = null,
  outputFile = null,
  contact = "",
  response_type = ""
) => {
  try {
    const formData = new FormData();
    formData.append("client_name", clientName);
    formData.append("account_name", accountName);
    formData.append("context", context);

    if (contextFile) {
      formData.append("contextFile", contextFile);
    }

    if (outputFile) {
      formData.append("outputFile", outputFile);
    }
    formData.append("contact_name", contact);

    if (response_type) {
      formData.append("response_type", response_type);
    }

    const response = await api.post(
      "/notes/get_delivery_excellence",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: response_type === "pdf" ? "blob" : "json",
      }
    );

    // let result = response?.data?.result ?? [];
    // return result;

    if (response_type === "pdf") {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "delivery_excellence.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      let result = response?.data?.result ?? [];
      return result;
    }
  } catch (error) {
    console.log(error);
    console.error("Fetch Delivery Excellence Agent Error:", error);
    throw error;
  }
};

export const fetchRenewalAgent = async (
  accountName = "",
  personaName = "",
  consumptionDataFile = null,
  outputFile = null,
  account_id = "",
  response_type = ""
) => {
  try {
    const formData = new FormData();
    formData.append("account_name", accountName);
    formData.append("contact_name", personaName);
    formData.append("account_id", account_id);

    if (consumptionDataFile) {
      formData.append("consumption_data", consumptionDataFile); // Append file
    }

    if (outputFile) {
      formData.append("outputfile", outputFile); // Append file
    }

    if (response_type) {
      formData.append("response_type", response_type);
    }

    const response = await api.post("/notes/get_renewal_note", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: response_type === "pdf" ? "blob" : "json",
    });

    // let result = response?.data?.result ?? [];
    // return result;

    if (response_type === "pdf") {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "renewal_note.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return true;
    } else {
      let result = response?.data?.result ?? [];
      return result;
    }
  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};

export const fetchLiveAccountsAgent = async () => {
  try {
    const response = await api.get("/notes/get_live_accounts");
    // console.log("LIVE ACCOUNTS: "+JSON.stringify(response));
    let result = response?.data?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};

export const createDemoRequest = async (
  requestType = "",
  roundOfDemo = "",
  sellerAccountName = "",
  buyerAccountName = "",
  sellerIndustry = "",
  buyerIndustry = "",
  demoDateTime = "",
  question = "",
  salesPersonNameAndDesignation = "",
  icpNameAndDesignation = "",
  productListCsv = null, //file
  csvData = ""
  // demoStartTime = '',
  // demoCompletionTime = '',
  // email = '',
  // name = '',
  // readyState = '',
  // detailsSentToRequestor = '',
  // demoFeedback = '',
  // qcedByProduct = '',
  // qcedByResearch = '',
  // deliveredToRequestor = '',
) => {
  try {
    const formData = new FormData();
    formData.append("requestType", requestType);
    formData.append("roundOfDemo", roundOfDemo);
    formData.append("sellerAccountName", sellerAccountName);
    formData.append("buyerAccountName", buyerAccountName);
    formData.append("sellerIndustry", sellerIndustry);
    formData.append("buyerIndustry", buyerIndustry);
    formData.append("demoDateTime", demoDateTime);
    formData.append("question", question);
    formData.append(
      "salesPersonNameAndDesignation",
      salesPersonNameAndDesignation
    );
    formData.append("icpNameAndDesignation", icpNameAndDesignation);
    formData.append("csvData", csvData);
    if (productListCsv) {
      formData.append("productListCsv", productListCsv); // Append file
    }
    // formData.append("demoStartTime", demoStartTime);
    // formData.append("demoCompletionTime", demoCompletionTime);
    // formData.append("email", email);
    // formData.append("name", name);
    // formData.append("productListCsv", productListCsv);
    // formData.append("readyState", readyState);
    // formData.append("detailsSentToRequestor", detailsSentToRequestor);
    // formData.append("demoFeedback", demoFeedback);
    // formData.append("qcedByProduct", qcedByProduct);
    // formData.append("qcedByResearch", qcedByResearch);
    // formData.append("deliveredToRequestor", deliveredToRequestor);

    const response = await api.post(
      "/demo_request/add_demo_request",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // let result = response?.data?.result ?? [];
    let result = response ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};

export const handleFeedbackDownloadBtn = async (id = "") => {
  try {
    const formData = new FormData();
    formData.append("id", id);

    const response = await api.post(
      "/demo_request/download_feedback_file",
      formData,
      {
        responseType: "blob", // Important for file downloads
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // Get filename from response headers if available
    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]
      : "account_plan.xlsx";

    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    console.error("Download failed:", error);
    // You might want to add user feedback here (e.g., toast notification)
  }
};

export const handleProductListDownload = async (id = "") => {
  try {
    const formData = new FormData();
    formData.append("id", id);

    const response = await api.post(
      "/demo_request/download_product_file",
      formData,
      {
        responseType: "blob", // Important for file downloads
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // Get filename from response headers if available
    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]
      : "account_plan.xlsx";

    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    console.error("Download failed:", error);
    // You might want to add user feedback here (e.g., toast notification)
  }
};

export const getDemoRequestsCreateAccount = async () => {
  try {
    const response = await api.get("/demo_request/get_list_to_create_account");
    let result = response?.data?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};

export const getSalesUsers = async () => {
  try {
    const response = await api.get("/users/get_sales_users_list");
    let result = response?.data?.data ?? [];
    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Renewal Agent Error:", error);
    throw error;
  }
};

export const fetchNudgesNew = async (clientName, accountName) => {
  try {
    const update_data = {
      client: clientName,
      account: accountName,
    };
    const queryString = qs.stringify(update_data, { skipNulls: false });
    const response = await iq_api_v2.post(
      "/nudges_v2/fetch_nudges?" + queryString
    );
    let result = response?.data ?? [];
    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Nudges Error:", error);
    throw error;
  }
};

export const fetchOperationsAndSupplyChain = async () => {
  try {
    const response = await iq_api.get("/operations_supply_chain");
    // console.log("OPERATIONS AND SUPPLY CHAINS: "+JSON.stringify(response));
    let result = response?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Operations And Supply Chains Error:", error);
    throw error;
  }
};

export const fetchCorporateAndOrgStructure = async (
  dimension = "",
  client = ""
  // subdimension_name = ""
) => {
  // const update_data = {
  //   dimension: dimension,
  //   // subdimension_name: subdimension_name,
  // };
  // const queryString = qs.stringify(update_data, { skipNulls: false });

  // +++++++++++++++++++++++++++++++++++++++++
  // const formData = new FormData();
  // formData.append("dimension", dimension);
  // formData.append("subdimension_name", subdimension_name);
  let query = {
    dimension: dimension,
    client: client,
  };
  // +++++++++++++++++++++++++++++++++++++++++

  try {
    // const response = await iq_api.get("/results", { params: query });
    const response = await iq_api.get("/benchmarks/benchmarking_results", {
      params: query,
    });
    // const response = await iq_api.post("/results", formData, {
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // });
    let result = response?.data ?? [];
    // console.log("CORPORATE AND ORG STRUCTURE: " + JSON.stringify(result));

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Corporate And Org Structure Error:", error);
    throw error;
  }
};

export const fetchCompetitorProfile = async (
  dimension = ""
  // subdimension_name = ""
) => {
  // const update_data = {
  //   dimension: dimension,
  //   // subdimension_name: subdimension_name,
  // };
  // const queryString = qs.stringify(update_data, { skipNulls: false });

  // +++++++++++++++++++++++++++++++++++++++++
  // const formData = new FormData();
  // formData.append("dimension", dimension);
  // formData.append("subdimension_name", subdimension_name);
  let query = { dimension: dimension };
  // +++++++++++++++++++++++++++++++++++++++++

  try {
    // const response = await iq_api.get("/comp_profile_results", {
    //   params: query,
    // });
    const response = await iq_api.get("/comp_profile_results_v2", {
      params: query,
    });
    // const response = await iq_api.post("/results", formData, {
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // });
    let result = response?.data ?? [];
    // console.log("CORPORATE AND ORG STRUCTURE: " + JSON.stringify(result));

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Competitor Profile Error:", error);
    throw error;
  }
};

export const fetchCompetitorProfileV1 = async (dimension = "") => {
  let query = { dimension: dimension };

  try {
    // const response = await iq_api.get("/comp_profile_results", {
    //   params: query,
    // });
    const response = await iq_api.get("/competitors/comp_profile_results", {
      params: query,
    });
    let result = response?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Competitor Profile Error:", error);
    throw error;
  }
};

export const fetchCompetitorProfileV3 = async (
  dimension = "",
  client = "",
  company = ""
) => {
  let query = { dimension: dimension, client: client, company: company };

  try {
    // const response = await iq_api.get("/comp_profile_results_v3", {
    //   params: query,
    // });

    // const response = await iq_api.get("/competitors/comp_profile_results_v3", {
    //   params: query,
    // });
    const response = await iq_api.get("competitors/comp_profile_results", {
      params: query,
    });
    // console.log("COMPETITOR PROFILE: " + JSON.stringify(response));
    let result = response?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Competitor Profile V3 Error:", error);
    throw error;
  }
};

export const fetchCompetitorProfileV4 = async (
  dimension = "",
  client = "",
  company = ""
) => {
  let query = { dimension: dimension, client: client, company: company };

  try {
    // const response = await iq_api.get("/comp_profile_results_v4", {
    //   params: query,
    // });
    // const response = await iq_api.get("/competitors/comp_profile_results_v4", {
    //   params: query,
    // });
    const response = await iq_api.get("competitors/comp_profile_results", {
      params: query,
    });
    // console.log("COMPETITOR PROFILE: " + JSON.stringify(response));
    let result = response?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Competitor Profile V4 Error:", error);
    throw error;
  }
};

export const getChatWindowResponse = async (queryParams = {}) => {
  try {
    const queryString = new URLSearchParams(queryParams).toString();

    const response = await iqChat(`/chatwindow?${queryString}`, {
      method: "POST",
    });

    if (!response.ok) {
      throw new Error(`ChatWindow API error: ${response.statusText}`);
    }

    return response;
  } catch (error) {
    console.error("ChatWindow API error:", error);
    throw error;
  }
};

// export const getLiveChatResponse = async (queryParams = {}) => {
//   try {
//     // const queryString = new URLSearchParams(queryParams).toString();

//     // const response = await iqChat(`/chat/stream?${queryString}`, {
//     //   method: "POST",
//     // });

//     const formData = new FormData();
//     formData.append("user_input", queryParams?.user_input);

//     const response = await fetch(`http://54.226.247.225:8000/chat`, {
//       method: "POST",
//       body: formData,
//       headers: {
//         // Don't set Content-Type for FormData; browser will set it correctly
//       },
//     });

//     if (!response.ok) {
//       throw new Error(`ChatWindow API error: ${response.statusText}`);
//     }

//     return response;
//   } catch (error) {
//     console.error("ChatWindow API error:", error);
//     throw error;
//   }
// };

export const getLiveChatResponse = async (queryParams = {}) => {
  try {
    const formData = new FormData();
    formData.append("user_input", queryParams?.user_input);

    const response = await iqChat(`/chat`, {
      method: "POST",
      body: formData,
    });

    return response;
  } catch (error) {
    console.error("ChatWindow API error:", error);
    throw error;
  }
};

export const fetchCompetitorList = async (client = "") => {
  let query = { client: client };

  try {
    const response = await iq_api.get("/competitors/get_competitors", {
      params: query,
    });
    // console.log("COMPETITOR PROFILE: " + JSON.stringify(response));
    let result = response?.data ?? [];

    return result;
  } catch (error) {
    console.log(error);
    console.error("Fetch Competitor List Error:", error);
    throw error;
  }
};

export const searchCompetitor = async (searchString = "") => {
  let query = { search_string: searchString };

  try {
    const response = await iq_api.get("/competitors/search_company", {
      params: query,
    });

    let result = response?.data ?? {};

    return result;
  } catch (error) {
    console.log(error);
    console.error("Search Competitor Suggestions Error:", error);
    throw error;
  }
};

// export const createCompetitor = async (client, competitor, competitorId) => {
//   try {
//     const payload = {
//       client,
//       competitor,
//       company_id: competitorId,
//     };
//     const payloadForFinancials = {
//       company_name: competitor,
//       identifier: competitorId,
//     };
//     // POST request with body
//     // const response = await iq_api.post("/create_competitors", payload);

//     const queryString = qs.stringify(payload, { skipNulls: false });
//     const queryStringForFinancials = qs.stringify(payloadForFinancials, {
//       skipNulls: false,
//     });
//     const response = await iq_api.post(
//       "/competitors/create_competitors_new?" + queryString
//     );

//     const responseForFinancials = await iq_api.post(
//       "/financials/insert_finanials_data_new?" + queryStringForFinancials
//     );

//     return response ?? {};
//   } catch (error) {
//     console.error("Create Competitor error:", error);
//     throw error;
//   }
// };

export const createCompetitor = async (client, competitor, competitorId) => {
  try {
    // Create the payload for the competitor creation API
    const payload = {
      client,
      competitor,
      company_id: competitorId,
    };

    const payloadForFinancials = {
      company_name: competitor,
      identifier: competitorId,
    };

    // Create the query string for the competitor creation
    const queryString = qs.stringify(payload, { skipNulls: false });
    const queryStringForFinancials = qs.stringify(payloadForFinancials, {
      skipNulls: false,
    });

    // First API call: Create Competitor
    const createCompetitorResponse = await iq_api.post(
      "/competitors/create_competitors?" + queryString
    );

    let insertFinancialsResponse = {};
    // If the first API call is successful, proceed with the second API call
    if (
      payload?.company_id !== undefined &&
      payload?.company_id !== null &&
      payload?.company_id !== "" &&
      createCompetitorResponse.status === 200
    ) {
      insertFinancialsResponse = await iq_api.post(
        "/financials/insert_finanials_data?" + queryStringForFinancials
      );

      // Return the response of both API calls if necessary
      return {
        competitor: createCompetitorResponse.data,
        financials: insertFinancialsResponse.data,
      };
    } else if (createCompetitorResponse.status === 200) {
      return {
        competitor: createCompetitorResponse.data,
        financials: insertFinancialsResponse.data,
      };
    } else {
      throw new Error(
        "Failed to create competitor. Response status: " +
          createCompetitorResponse.status
      );
    }
  } catch (error) {
    console.error("Create Competitor error:", error);
    // Throw or handle the error appropriately
    throw new Error(
      "Error during competitor creation or financials insertion."
    );
  }
};

export const fetchFinancialsGiq = async (identifier = "") => {
  try {
    const get_data = {
      identifier: identifier,
    };
    const queryString = qs.stringify(get_data, { skipNulls: false });
    const response = await iq_api.post("/get_finanials?" + queryString);

    let result = response?.data ?? [];
    return result || [];
  } catch (error) {
    console.error("Fetch Financials error:", error);
    throw error;
  }
};

export const fetchFinancialsByCompanyNameGiq = async (competitor = "") => {
  try {
    const get_data = {
      company_name: competitor,
    };
    const queryString = qs.stringify(get_data, { skipNulls: false });
    const response = await iq_api.post(
      "/financials/get_finanials?" + queryString
    );

    // console.log("FIN DATA: " + JSON.stringify(response));
    let result = response?.data ?? [];
    return result || [];
  } catch (error) {
    console.error("Fetch Financials error:", error);
    throw error;
  }
};

export const getCompanyCodesByName = async (companies) => {
  // console.log("IN GET CODES METHOD: ", companies);
  try {
    // var response = [];

    // const post_data = qs.stringify();

    const response = await api.post("/companies/get_company_codes", {
      companies: companies,
    });
    let companyCodes = response || [];
    return companyCodes;
  } catch (error) {
    console.error("Company code error:", error);
    throw error;
  }
};

export const getKsCompanyDetails = async (ksCompanyCode) => {
  try {
    const response = await api.post("/companies/get_company_details", {
      ks_company_code: ksCompanyCode,
    });
    let companyDetails = response || [];

    return companyDetails;
  } catch (error) {
    console.error("Company details error:", error);
    throw error;
  }
};

export const exportRequest = async (downloadRequestData) => {
  try {
    const payload = {
      clientName: downloadRequestData?.client,
      competitorName: downloadRequestData?.competitor,
      export_all: true,
      is_authenticated: true,
    };

    const response = await iq_download.post("/api/pdf/export-report", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response?.data ?? {};
  } catch (error) {
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Response data:", error.response.data);
    } else {
      console.error("Error:", error.message);
    }
    throw error;
  }
};

export const fetchDocumentsV3 = async (compId) => {
  if (!compId) return [];

  try {
    // const formData = new FormData();
    // formData.append("ciq_id", compId);
    // formData.append("timestamp", Date.now());

    const formData = {
      company_id: compId,
      timestamp: Date.now(),
    };

    const response = await iq_api.post(`/company/get_files`, formData, {
      headers: {
        // "Content-Type": "multipart/form-data",
        "Content-Type": "application/json",
        // "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return response?.data?.records ?? [];
  } catch (error) {
    console.error("Fetch Documents error:", error);
    return [];
  }
};

export const getBaselineMarketDetails = async (client, company) => {
  try {
    const payload = {
      client,
      company,
    };
    // POST request with body
    // const response = await iq_api.post("/get_market_share", payload);

    const queryString = qs.stringify(payload, { skipNulls: false });
    const response = await iq_api.post("/get_market_share?" + queryString);

    return response ?? {};
  } catch (error) {
    console.error("Get baseline market details:", error);
    throw error;
  }
};

// ==========================================
// New API functions integrated from api.js
// ==========================================

/**
 * Fallback API to get files task
 * @param {string} companyId - Company ID (CIQ ID)
 * @returns {Promise<Object>}
 */
export const getFilesTask = async (companyId) => {
  if (!companyId) return null;
  try {
    // const response = await iq_api.post("/company/get_files_task", {
    //   company_id: companyId,
    // });
    const response = await iq_api.post(
      "/company/get_files_task",
      { company_id: companyId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data ?? null;
  } catch (error) {
    console.error("Get Files Task error:", error);
    throw error;
  }
};

/**
 * Search for news companies/keywords
 * @param {string} term - Search term
 * @returns {Promise<Array<{label: string, value: string, type: string}>>}
 */
export const getSearchKeywords = async (term) => {
  try {
    const response = await api.post(
      `/companies/searchCompany`,
      // {
      //   api_key: process.env.REACT_APP_NEWS_API_KEY || "ZTNmZWE1NmJhNTVkNWI0ZTQyMmRlYTA5OWI3ODQyZGUwMDk0M2ZhM2I1NjBkMGYzNzk3NjVmYmI5OWUyN2U3Yb743aoCbGQNYYcXPjVf28xoZVSXj5rDlidbNY8o14qQ5Qn-hBAENs8S9-QZcUsA9Q,,",
      //   term: term
      // }
      { term }
    );

    // Transform response data to match expected format
    // API returns: { data: [{ code: "ibm", name: "IBM CORPORATION" }, ...] }
    const companies = response?.data?.data ?? [];

    // Map to the format expected by NewsSelector
    return companies.map((company) => ({
      label: company.name,
      value: company.code,
      type: "company",
    }));
  } catch (error) {
    console.error("Search Keywords error:", error);
    return []; // NEVER throw for search
  }
};

/**
 * Create company in KS system
 * @param {Object} params - Company creation parameters
 * @param {string} params.name - Company name
 * @param {string} params.vendor_company_id - Vendor company ID from SalesPlay
 * @param {string} params.website - Company website from SalesPlay
 * @returns {Promise<Object>}
 */
export const createCompanyInKS = async ({
  name,
  vendor_company_id,
  website,
}) => {
  try {
    const response = await api.post(`/companies/add_company_with_images`, {
      name,
      vendor_company_id,
      website,
      exchange: "",
      ticker: "",
    });
    return response?.data ?? {};
  } catch (error) {
    console.error("Create Company in KS error:", error);
    throw error;
  }
};

/**
 * Start a revenue teardown task
 * @param {string} companyName - Company name
 * @param {string} ciqId - Company CIQ ID
 * @param {File|null} pdfFile - Optional PDF file for revenue teardown
 * @param {string} expectedcurrency - Expected currency for revenue teardown
 * @returns {Promise<{task_id: string}>}
 */
export const startRevenueTeardown = async (
  companyName,
  ciqId,
  pdfFile = null,
  expectedcurrency
) => {
  try {
    const formData = new FormData();
    formData.append("company_name", companyName);
    formData.append("ciq_id", ciqId);
    formData.append("expected_currency", expectedcurrency);
    if (pdfFile) {
      formData.append("pdf_file", pdfFile);
    }
    const response = await revenue_teardown_api.post(
      "/revenue_teardown",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response?.data ?? {};
  } catch (error) {
    console.error("Start Revenue Teardown error:", error);
    throw error;
  }
};

/**
 * Insert financials data for a company (standalone version)
 * @param {string} companyName - Company name
 * @param {string} identifier - Company identifier (ciq_id)
 * @returns {Promise<Object>}
 */
export const insertFinancialsDataStandalone = async (
  companyName,
  identifier
) => {
  try {
    const payload = { company_name: companyName, identifier };
    const queryString = qs.stringify(payload, { skipNulls: false });
    const response = await iq_api.post(
      "/financials/insert_finanials_data?" + queryString
    );
    return response?.data ?? {};
  } catch (error) {
    console.error("Insert Financials Data error:", error);
    throw error;
  }
};

/**
 * Generate company profile using the new create_competitors_new API
 * @param {string} client - Client company name (user's company)
 * @param {string} competitorName - Competitor company name (from Financial Details)
 * @param {string} user_id - User ID
 * @param {string} user_type - growth_iq
 * @param {Array<string>} ksCompanies - List of KS company codes selected from news
 * @param {string} companyId - Company CIQ ID (optional)
 * @param {string} region - Region (optional, blank if "global")
 * @param {string} bu - Business unit (optional, blank if same as competitor name)
 * @param {string} industry - Industry
 * @param {Array<string>} subdimensions - Selected subdimension keys (optional)
 * @returns {Promise<Object>}
 */
export const generateProfile = async (
  client,
  competitorName,
  user_id,
  user_type,
  ksCompanies = [],
  companyId = "",
  region = "",
  bu = "",
  industry = "",
  subdimensions = []
) => {
  try {
    // Query parameters (sent in URL)
    const queryParams = {
      client,
      competitor_name: competitorName,
      industry,
      user_id,
      user_type,
    };

    // Only include company_id if it has a non-empty value
    if (companyId && companyId.trim() !== "") {
      queryParams.company_id = companyId;
    }

    // Only include region if it has a non-empty value
    if (region && region.trim() !== "") {
      queryParams.region = region;
    }

    // Only include bu if it has a non-empty value
    if (bu && bu.trim() !== "") {
      queryParams.bu = bu;
    }

    const queryString = qs.stringify(queryParams, { skipNulls: false });

    // Request body: ks_companies + selectedDimensions
    const requestBody = {
      ks_companies: ksCompanies,
      subdimensions: subdimensions,
    };

    // const response = await iq_api.post(
    //   "/competitors/create_competitors_new?" + queryString,
    //   requestBody,
    //   {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   }
    // );
    const response = await iq_api.post(
      "/competitors/create_competitors?" + queryString,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data ?? {};
  } catch (error) {
    console.error("Generate Profile error:", error);
    throw error;
  }
};

/**
 * Helper function to filter valid AR files
 * Files must be AR, 10-K, or 20-F type and filed within last 15 months
 * @param {Array} files - Array of file records
 * @returns {Array}
 */
export const filterValidARFiles = (files) => {
  if (!files || !Array.isArray(files)) return [];

  const fifteenMonthsAgo = new Date();
  fifteenMonthsAgo.setMonth(fifteenMonthsAgo.getMonth() - 15);

  const validFiles = files.filter((file) => {
    const filingDate = new Date(file.filingDate || file.filing_date);
    return filingDate >= fifteenMonthsAgo;
  });

  // Prefer AR, then 10-K, then 20-F
  const arFiles = validFiles.filter(
    (f) => f.fileType === "AR" || f.file_type === "AR"
  );
  if (arFiles.length > 0) return arFiles;

  const tenKFiles = validFiles.filter(
    (f) => f.fileType === "10-K" || f.file_type === "10-K"
  );
  if (tenKFiles.length > 0) return tenKFiles;

  return validFiles.filter(
    (f) => f.fileType === "20-F" || f.file_type === "20-F"
  );
};

/**
 * Wait for specified milliseconds
 * @param {number} ms - Milliseconds to wait
 * @returns {Promise<void>}
 */
export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Download a PDF file for preview
 * @param {string} filingVersionId - Filing version ID from the file record
 * @returns {Promise<{blob: Blob, url: string}>}
 */
export const downloadPdfForPreview = async (filingVersionId) => {
  try {
    const response = await iq_api.post(`/company/download_file`, null, {
      responseType: "blob",
      params: { filingVersionId: filingVersionId },
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    return { blob, url };
  } catch (error) {
    console.error("Download PDF for preview error:", error);
    throw error;
  }
};

export const getSandPCompanyDetails = async (identifier = "") => {
  try {
    const response = await sales_iq_v2_api.post(
      "/company/initiate_account_plan_generation",
      {
        company_id: identifier,
      }
    );

    let result = response?.data ?? [];
    return result || [];
  } catch (error) {
    console.error("Fetch Company Details error:", error);
    throw error;
  }
};

export const toggleCompetitorStatus = async ({ client, company, flag }) => {
  let api_url = "/competitors/competitor_is_active";

  if (api_url) {
    try {
      const response = await iq_api.get(api_url, {
        params: {
          client,
          company,
          flag,
        },
      });

      if (response.data.status === 200 || response.data.status === 201) {
        return response?.data?.result || {};
      } else {
        return {};
      }
    } catch (error) {
      console.error("Failed to toggle competitor status:", error);
      throw error;
    }
  }
};

export const createSuggestedCompetitor = async (
  user_id,
  user_type,
  client,
  competitor,
  company_id,
  ksCompanies,
  industry
) => {
  try {
    const payload = {
      user_id: user_id,
      user_type: user_type,
      client: client,
      competitor: competitor,
      company_id: company_id,
      industry: industry,
    };

    const queryString = qs.stringify(payload, { skipNulls: false });

    const response = await iq_api.post(
      "/competitors/create_competitors_marketiq?" + queryString,
      ksCompanies,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response?.status === 200 || response?.status === 201) {
      return response.data;
    }

    throw new Error("Failed to create competitor");
  } catch (error) {
    console.error("Create Suggested Competitor error:", error);
    throw error;
  }
};

export const createSuggestedCompetitorNew = async (
  user_id,
  user_type,
  client,
  competitor,
  company_id,
  subdimensions,
  ksCompanies,
  industry
) => {
  try {
    const payload = {
      user_id: user_id,
      user_type: user_type,
      client: client,
      competitor_name: competitor,
      company_id: company_id,
      industry: industry,
    };

    const queryString = qs.stringify(payload, { skipNulls: false });

    // Request body: ks_companies + selectedDimensions
    const requestBody = {
      ks_companies: ksCompanies,
      subdimensions: subdimensions,
    };

    const response = await iq_api.post(
      "/competitors/create_competitors?" + queryString,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response?.status === 200 || response?.status === 201) {
      return response.data;
    }

    throw new Error("Failed to create competitor");
  } catch (error) {
    console.error("Create Suggested Competitor error:", error);
    throw error;
  }
};

export const fetchSuggestedCompetitors = async (params = {}) => {
  try {
    const response = await api.get("/companies/get_suggested_competitors");

    if (response.status === 200 || response.status === 201) {
      return response.data;
    }

    throw new Error("Failed to fetch suggested competitors");
  } catch (error) {
    console.error("Fetch Suggested Competitors error:", error);
    throw error;
  }
};

/**
 * Get Growth IQ company listing
 * @param {string} searchText - Company name to search
 * @returns {Promise<Object>}
 */
export const getGrowthIqListing = async (searchText) => {
  if (!searchText) return null;

  try {
    const response = await api.post("/companies/get_growth_iq_listing", {
      search: searchText,
    });

    return response?.data ?? null;
  } catch (error) {
    console.error("Get Growth IQ Listing error:", error);
    throw error;
  }
};

export const fetchClientsWithIndustries = async () => {
  const api_url = "/company/company_details";

  try {
    const response = await iq_api.post(api_url);

    return response.data ? response.data : [];

    throw new Error("Invalid response");
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (email) => {
  if (!email) return null;

  try {
    const response = await api.post("/users/forgot_password", {
      email: email?.email,
    });

    return response?.data ?? null;
  } catch (error) {
    console.error("Forgot Password error:", error);
    throw error;
  }
};

// Upload document to memory
export const uploadDocument = async (
  userId,
  client,
  memoryType,
  documentType,
  files
) => {
  try {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("client", client);
    formData.append("memory_type", memoryType);
    formData.append("document_type", documentType);
    files.forEach((file) => formData.append("file", file));

    const response = await iq_api.post("/memory/upload-document", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response?.data ?? null;
  } catch (error) {
    console.error("Upload Document error:", error);
    throw error;
  }
};

// List documents from memory (paginated)
export const listDocuments = async (userId, client, page = 1, limit = 5) => {
  try {
    const response = await iq_api.get("/memory/list", {
      params: { user_id: userId, client, memory_type: "global", page, limit },
    });

    return (
      response?.data ?? {
        total: 0,
        page: 1,
        limit,
        total_pages: 1,
        results: [],
      }
    );
  } catch (error) {
    console.error("List Documents error:", error);
    throw error;
  }
};

// Delete a document from memory
export const deleteDocument = async (documentId) => {
  try {
    const response = await iq_api.delete(`/memory/${documentId}`);
    return response?.data ?? null;
  } catch (error) {
    console.error("Delete Document error:", error);
    throw error;
  }
};
